module.exports = __webpack_public_path__ + "8498d7c0bfcf09664d8a803ac05f9536.MP3";